import type { Translation } from '@subaio/api-types/shared'
import { type Store as StoreBase, storeCreate as storeCreateBase } from '@subaio/utils'
import { type ContainerState, ContainerStatus } from '@subaio/webapp/src/containers'

export type User = {
	token: string
	userId: string
	expiration: number
}

export type UserAuth = { status: 'authenticated'; user: User } | { status: 'unauthenticated' } | { status: 'expired' }
export type UserAuthStatus = UserAuth['status']

export type State = ContainerState & {
	translation: Translation | null
	userAuth: UserAuth
}
export type Store = StoreBase<State>

export const defaultState: State = {
	page: { name: 'NotFound' },
	status: ContainerStatus.Running,

	translation: null,
	userAuth: { status: 'unauthenticated' },
	data: {},
}

export const storeCreate = (state: State = defaultState) => storeCreateBase<State>(state)
